import { createAsyncThunk } from '@reduxjs/toolkit';
import { orderProduct } from 'shared/api/apiOrder';

export const doAddToCart = createAsyncThunk(
  'cart/doAddToCart',
  (form) => orderProduct(form),
);
